import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { VolumeReportComponent } from './volume-report.component';

@NgModule({
    imports: [TwcModule, CommonModule, TranslateModule],
    declarations: [VolumeReportComponent],
    exports: [VolumeReportComponent],
})
export class VolumeReportModule {}
